<a  href="javascript:void(0)" class="edit-grid" (click)="openImage(file)"> 
<img [src]="img$ | async" width="15px" height="15px" ></a>

